import { useEffect } from 'react';
import { useNavigationManager } from '@provider/navigation';
import { IArkContent } from '../root.content/_content.js';
import { iArkStore } from '../state/store.js';
import { jsx } from 'react/jsx-runtime';

function StandaloneWrapper(props) {
  const navigation = useNavigationManager();
  const dispatch = iArkStore.useDispatch();
  useEffect(() => {
    return navigation.subscribe(() => {
      if (props.context === "lightbox") {
        props.rootRef.current?.scrollIntoView({
          block: "start",
          behavior: "auto"
        });
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    });
  }, [navigation, props.context, props.rootRef]);
  useEffect(() => {
    if (props.context !== "standalone") {
      return;
    }
    const onBeforePrint = async () => {
      dispatch(iArkStore.actions.togglePrintLayout(true));
    };
    const onAfterPrint = () => {
      dispatch(iArkStore.actions.togglePrintLayout(false));
    };
    window.addEventListener("beforeprint", onBeforePrint);
    window.addEventListener("afterprint", onAfterPrint);
    return () => {
      window.removeEventListener("beforeprint", onBeforePrint);
      window.removeEventListener("afterprint", onAfterPrint);
    };
  }, [dispatch, props.context]);
  return /*#__PURE__*/jsx(IArkContent, {
    ...props
  });
}

export { StandaloneWrapper };
//# sourceMappingURL=variant.standalone.js.map
